module.exports = __webpack_public_path__ + "static/media/Rectangle.a1607831.svg";